import { Layout, Typography, Row, Col, Form, Input, Card, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const { Text } = Typography;

const ViewbranchTypeForm = ({
  allowedPaymentTypeData,
  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
  selectedBranchTypeKey,
}) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  useEffect(() => {
    getBranchTypeById(selectedBranchTypeKey.id);
  }, []);

  const onCancel = () => {
    navigate("/sya0300", { replace: false });
  };

  const getBranchTypeById = (id) => {
    const url = `${apiConfig.Officetype}/${id}?template=true`;
    const body = { session };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const formValues = {
          name: res?.name || "",
          allowedPaymentTypes:
            res?.configuredPaymentTypes?.map((item) => item.name) || [],
        };

        form.setFieldsValue(formValues);
        setIsLoading(false);
      }
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ paddingTop: 20 }}
    >
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
        title="View Branch Type"
      >
        <Card
          style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          }}
        >
          <Row gutter={24} style={{ justifyContent: "space-between" }}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="name"
                label={<Text strong>Name</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input placeholder="Enter Branch Name" className="of-bold-disable-input" disabled/>
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="allowedPaymentTypes"
                label={<Text strong>Allowed Payment Types</Text>}
                rules={[
                  {
                    required: true,
                    message: "Please select payment types",
                  },
                ]}
                className="of-bold-disable-input"
                
              >
                <Select
                  mode="multiple"
                  showSearch
                  placeholder="Select Options"
                  options={allowedPaymentTypeData}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Card>
    </Form>
  );
};

export default ViewbranchTypeForm;
